package org.catharsis.spendtel.feature.presentation.web

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.imePadding
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.rememberScrollState
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.SnackbarHost
import androidx.compose.material3.SnackbarHostState
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import androidx.navigation.NavHostController
import kotlinx.coroutines.launch
import org.catharsis.spendtel.feature.legal.LegalConstants
import org.catharsis.spendtel.feature.presentation.expensereport.SpendTelReportColors
import org.catharsis.spendtel.feature.support.ContactSupportForm

private val webSupportMaxWidth = 720.dp

@Composable
fun WebContactSupportScreen(
    navHostController: NavHostController,
    defaultName: String?,
    defaultEmail: String?,
) {
    val scrollState = rememberScrollState()
    val snackbarHostState = remember { SnackbarHostState() }
    val coroutineScope = rememberCoroutineScope()

    Box(
        modifier = Modifier
            .fillMaxSize()
            .imePadding(),
    ) {
        WebAmbientPageBackground(modifier = Modifier.fillMaxSize())

        WebViewportScrollColumn(
            scrollState = scrollState,
            modifier = Modifier.fillMaxSize(),
            maxContentWidth = webSupportMaxWidth,
        ) {
            Column(
                modifier = Modifier.padding(horizontal = 24.dp, vertical = 32.dp),
                verticalArrangement = Arrangement.spacedBy(24.dp),
            ) {
                WebBackLink(
                    label = "Back",
                    onClick = { navHostController.popBackStack() },
                )

                WebSectionHeader(
                    title = "Contact support",
                    subtitle = "Questions about billing, your account, or your spending stories? Send us a quick note.",
                )

                WebAccentCard {
                    ContactSupportForm(
                        defaultName = defaultName,
                        defaultEmail = defaultEmail,
                        modifier = Modifier.padding(20.dp),
                        onSubmitted = { openedMailClient ->
                            coroutineScope.launch {
                                snackbarHostState.showSnackbar(
                                    if (openedMailClient) {
                                        "Opening your email app…"
                                    } else {
                                        "Couldn't open Mail. Email us at ${LegalConstants.SUPPORT_EMAIL}."
                                    },
                                )
                            }
                        },
                    )
                }

                Text(
                    text = "Prefer email? Reach us at ${LegalConstants.SUPPORT_EMAIL}.",
                    style = MaterialTheme.typography.bodyMedium,
                    color = SpendTelReportColors.inkMuted,
                )
            }
        }

        SnackbarHost(
            hostState = snackbarHostState,
            modifier = Modifier.align(androidx.compose.ui.Alignment.BottomCenter),
        )
    }
}
